<template>
    <div v-if="rLojas.length > 1">
        <label for="loja">
            {{ label }}
        </label>
        <template v-if="multi">
            <multi-select
                id="loja"
                v-model="filtro.loja"
                :options="rLojas"
                :enableSelectionAll="false"
            />            
        </template>
        <template v-else>
            <b-form-select
                id="lojas"
                :options="rLojas"
                v-model="filtro.loja"
            >
                <template #first v-if="exibe_busca_todos">
                    <b-form-select-option value="">
                        Todas
                    </b-form-select-option>
                </template>
            </b-form-select>
        </template>
    </div>
</template>
<script>
import MultiSelect from '@/shared/components/ui/MultiSelect'
export default {
    components: {
        MultiSelect 
    },
    props: {
        label: {
            default: 'Loja'
        },
        filtro: {
            default: null
        },
        lojas: {
            default: null
        },
        multi: {
            default: true
        },
        exibe_busca_todos: {
            default: true
        }
    },
    data(){
        return {
            rLojas: []
        }
    },
    mounted() {
        
        if(this.lojas){
            this.rLojas = this.lojas;
        }else{
            this.rLojas = Object.entries(this.$usuarioLogado.UsuarioLojas).map(
                item => {
                    return {
                        value: Object.values(item)[1].UsuariosLoja.loja_id,
                        text: Object.values(item)[1].Loja.nome
                    }
                }
            )
        }
    }
}
</script>